import React from 'react';
import { useTranslation } from 'react-i18next';

export const ChangePhoneHeader = () => {
  const { t } = useTranslation();

  return (
    <div className='flex flex-col justify-center items-center pb-[40px]' id='header'>
      <p className='text-bw08 text-2xl font-metricRMedium w-full text-center '>{t('CHANGE_PHONE.TITLE')}</p>
      <p className='text-bw07 text-base font-metricR tracking-[-0.4px]'>{t('CHANGE_PHONE.SUB_HEADER')}</p>
    </div>
  );
};

export default ChangePhoneHeader;
